import { get, post } from '@/utils/service';
import { obj2string } from '@/utils/url';
import { uniRequest } from '@/utils/httpRequest';
import { getOrigin } from '@/config/env';

export const userapi = {
    // 获取用户信息
    async getProfile() {
        const { data } = await uniRequest.get(`${getOrigin('api')}/v2/private/user/profile`, {
            useCache: true,
        });
        return data;
    },

    // 获取websocket token
    getWsToken() {
        return post('@api2/user/private/ott');
    },

    // 现货 POST 是 urlencode 模式
    getPostSpotDataDemo() {
        return post('url', obj2string({}), { headers: {} });
    },

    // 退出登录
    logout() {
        return post('@api2/logout', {}, { timeout: 2000 });
    },

    // 设置收藏币种
    setPrefSetting(params) {
        return post('@api2/v3/private/user/member/pref-setting', params);
    },

    // 获取收藏币种
    getPreferences(params) {
        return post('@api2/v3/private/user/member/preferences', params);
    },

    // 获取用户kyc状态
    getKyc(params) {
        return post('@api2/v3/private/user/member/kyc-info', params);
    },

    // 获取用户邀请码
    getInvitationCode(params) {
        return get('@api2/s1/code/info-msg', { params });
    },

    // 资产接口-获取单账户币种余额
    getCoinBalance(params) {
        return get('@api2/v3/private/asset/account/coin-balance', { params });
    },
};

export const commonapi = {
    getLegalRate(name) {
        // return fetchWorker(`${getOrigin({ type: 'api' })}/api/exchange-rate?name=${name.toUpperCase()}`);
        return get(`@api2/api/exchange-rate?name=${name.toUpperCase()}`);
    },

    // 获取广告列表
    getNotices(params) {
        return post('@api2/v3/config/banner', params);
    },
    // 获取分享链接
    getShareCode(params) {
        return post('@api2/s1/invitation-plan/v2/get-code', params);
    },

    // 获取手机区号
    getPhoneAreaList() {
        return get('@api2/v2/public/country-list');
    },

    // 获取资产页币种列表（精度）
    getAssetCurrencyList(params) {
        return get('@api2/v3/private/cht/asset-common/coin-config', { params });
    },

    // 获取交易机器人支持的币对
    getTradeBotList() {
        return post('@api2/s1/bot/grid/v1/list-symbol-info');
    },
    // 获取 deadpool 的配置
    getDeadPool(params) {
        return post('@deadpoolapi2/v3/config/web', params);
    },
};

export const swapapi = {
    getSwapSymbols() {
        return get('@api2/v3/private/instrument/dynamic-symbol');
    },
};

export const unified = {
    // 获取保证金预警线
    getWarnLine(params) {
        return post('@api2/option/usdc/public/optionmp/query/config/global', params);
    },
};

// 用户触达
export const notice = {
    // 获取用户触达消息订阅状态
    getSubscribe(params) {
        return post('@notice/v1/private/user_group/get_subscribe', params);
    },
    // 设置用户触达消息订阅状态
    setSubscribe(params) {
        return post('@notice/v1/private/user_group/set_subscribe', params);
    },
};
